var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModalCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.194,
    height: 19.649,
    viewBox: "0 0 19.194 19.649",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_352",
    "data-name": "Path 352",
    d: "M2.849,1.745a1.089,1.089,0,0,0-.777.33,1.15,1.15,0,0,0,0,1.591L9.8,11.57l-7.723,7.9a1.15,1.15,0,0,0,0,1.591,1.081,1.081,0,0,0,1.555,0l7.723-7.9,7.723,7.9a1.1,1.1,0,0,0,.777.33,1.076,1.076,0,0,0,.777-.33,1.15,1.15,0,0,0,0-1.591L12.9,11.57l7.723-7.9a1.15,1.15,0,0,0,0-1.591,1.088,1.088,0,0,0-1.554,0l-7.723,7.9-7.723-7.9a1.089,1.089,0,0,0-.777-.33Z",
    transform: "translate(-1.752 -1.745)",
    fill: "#26262a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalCloseIcon);
export default __webpack_public_path__ + "static/media/modal-close-icon.8f45a3006f1e758da7cdaedf17fddf4b.svg";
export { ForwardRef as ReactComponent };